export default "__VITE_ASSET__CqIimxBv__"